import {
    updateAccounting,
    updateFactor,
    updateForm,
    updateInstallment,
    updateRemittance,
    updateTransaction,
    updateTransfer,
} from "../../store/actions/formAction";

export const updateInput = (
    dispatch,
    formType = "form",
    inputName,
    value,
    primary = false,
    updateFlag = false
) => {
    if (formType === "factor") {
        dispatch(updateFactor(inputName, value));
    } else if (formType === "accounting") {
        dispatch(updateAccounting(inputName, value));
    } else if (formType === "transaction") {
        dispatch(updateTransaction(inputName, value));
    } else if (formType === "remittance") {
        dispatch(updateRemittance(inputName, value));
    } else if (formType === "transfer") {
        dispatch(updateTransfer(inputName, value));
    } else if (formType === "installment") {
        dispatch(updateInstallment(inputName, value));
    } else {
        dispatch(updateForm(inputName, value, primary, updateFlag));
    }
};

export const findValue = (formData, formType = "form", inputName, defaultValue) => {
    let form = formData.forms;
    if (formType === "factor") {
        form = formData.factor ?? {};
    } else if (formType === "accounting") {
        form = formData.accounting ?? {};
    } else if (formType === "transaction") {
        form = formData.transaction ?? {};
    } else if (formType === "remittance") {
        form = formData.remittance ?? {};
    } else if (formType === "transfer") {
        form = formData.transfer ?? {};
    } else if (formType === "installment") {
        form = formData.installment ?? {};
    }

    const activeIndex = formData.activeIndex ?? 0;
    const objectForm = ["factor", "transaction", "remittance", "transfer", "accounting", "installment"];

    let value = form[inputName] !== undefined ? form[inputName] : defaultValue;
    if (!objectForm.includes(formType) && !value) {
        value = findFormInputValue(form, activeIndex, inputName, defaultValue);
    }
    return value;
};

export function findFormInputValue(formData, activeIndex, inputName, defaultValue = null) {
    const form = formData.find((f) => f.index === activeIndex);
    return form?.main[inputName] ?? form?.others[inputName] ?? defaultValue;
}

export const getOptions = (options, state) => {
    if (typeof options === "string") {
        switch (options) {
            case "currencies":
                return state.currencyReducer.currencies;
            case "businessCurrencies":
                const defId = state.businessReducer.business.business.default_currency_id
                const defCurrency = state.currencyReducer.currencies.find(c => c.id === defId)
                return [defCurrency,
                    ...state.currencyReducer.businessCurrencies];
            case "personCategories":
                return state.categoryReducer.personCategories;
            case "persons":
                return [
                    ...(state.personReducer.customers ?? []),
                    ...(state.personReducer.personnel ?? []),
                    ...(state.personReducer.providers ?? []),
                ];
            case "customers":
                return state.personReducer.customers;
            case "personnel":
                return state.personReducer.personnel;
            case "sellers":
                return state.personReducer.sellers;
            case "providers":
                return state.personReducer.providers;
            case "productCategories":
                return state.categoryReducer.productCategories;
            case "products":
                return state.productReducer.products;
            case "branches":
                return state.branchReducer.branches;
            case "projects":
                return state.projectReducer.projects;
            case "roles":
                return state.roleReducer.roles;
            case "banks":
                return state.financialReducer.banks;
            case "funds":
                return state.financialReducer.funds;
            case "cashiers":
                return state.financialReducer.cashiers;
            case "inventories":
                return state.warehouseReducer.warehouses;
            case "factors":
                return state.factorReducer.factors;
            case "cheques":
                return state.chequeReducer.cheques;
            case "installment":
                return state.installmentReducer.installments;
            // return state.personReducer.providers
            default:
                break;
        }
    }
    return options;
};
